import Part from "@/components/body/parts/part";
import { Colors } from "@/components/shared/util";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import SVG from "svg.js";
import { Store } from "vuex";
import { BodyConfig } from ".";

export default class Spine extends Part {
  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
  }

  getExtraData(data: Patient) {
    this.extraData = _.get(data.body.atoms, "inr", { alert: "" });
  }

  updateData(patient: Patient | null) {
    super.updateData(patient);
    if (!patient || !this.atom || !this.atom.value) {
      return;
    }

    let fill: Colors | null = null;
    if (this.atom.value > 1 || this.extraData.alert) {
      fill = Colors.Red;
    } else if (this.atom.value === 1) {
      fill = Colors.Yellow;
    }
    if (fill) {
      this.levelElements.forEach(element => {
        element.attr({ fill });
      });
    }
  }
}
